import { getConfig } from '@base/constants';
import { updateLinkParams } from '@base/utils';

const {
	isTestServer,
	hosts: {
		baseUrl = '/',
	},
} = getConfig();
const baseLocation = isTestServer ? baseUrl : '';

export const getSectionLink = (section: string, ref?: string) =>
	updateLinkParams(baseLocation + section, { ref });
